import { createContext, useState } from "react";

const AuditContext = createContext({});

export const AuditProvider = ({ children }) => {
  const [showAudit, setShowAudit] = useState(false);
  const [model, setModel] = useState("");
  const [srcId, setSrcId] = useState("");

  return (
    <AuditContext.Provider
      value={{ showAudit, setShowAudit, model, setModel, srcId, setSrcId }}
    >
      {children}
    </AuditContext.Provider>
  );
};

export default AuditContext;
